export const ACTIONS_MATERIAL = {
  INVALIDATE: 'MATERIALS_INVALIDATE',
  RECEIVE: 'MATERIALS_RECEIVE',
  DELETE: 'MATERIAL_DELETE',
  UPDATE: 'MATERIAL_UPDATE',
};

const materialConstants = {};

export default materialConstants;
